<div class="groups-AssignStudentsPopupMenu">
	<!--Event Short Description-->
	<div>
		<label>Event:</label>
		<label>{{ selectedDetails.EventDescShort }}</label>
	</div>
	<!--School?-->
	<div>
		<label>School:</label>
		<select
			[disabled]="Saving == true || SchoolLoading == true || GroupLoading == true || ValueLoading == true || AlertLoading == true"
			class="form-control"
			name="SchoolSelect"
			(ngModelChange)="onSchoolChange($event)"
			[(ngModel)]="selectedDetails.SchoolID"
		>
			<option value="" style="display: none"></option>
			<option *ngFor="let o of schoolList" [ngValue]="o.SchoolID">
				{{ o.SchoolNumber == undefined ? o.SchoolName : "[" + o.SchoolNumber + "] - " + o.SchoolName }}
			</option>
		</select>
	</div>

	<!--Select (Get values from Dynamic Group)-->
	<div>
		<label>Select:</label>
		<select
			[disabled]="Saving == true || SchoolLoading == true || GroupLoading == true || ValueLoading == true || AlertLoading == true"
			class="form-control"
			name="DynamicGroupSelect"
			(ngModelChange)="onDynamicGroupSelectChange($event)"
			[(ngModel)]="selectedDetails.DynamicGroupSelectID"
		>
			<option value="" style="display: none"></option>
			<option *ngFor="let o of dynamicGroupList" [ngValue]="o.DynamicGroupID">
				{{ o.DynamicGroupDesc }}
			</option>
		</select>
	</div>

	<!--Value (Get data based on the selected Dynamic Group)-->
	<div>
		<label>Value:</label>
		<select
			[disabled]="Saving == true || SchoolLoading == true || GroupLoading == true || ValueLoading == true || AlertLoading == true"
			class="form-control"
			name="DynamicValueSelect"
			[(ngModel)]="selectedDetails.DynamicValueSelectID"
		>
			<option value="" style="display: none"></option>
			<option *ngFor="let o of dynamicValueList" [ngValue]="o.ListID">
				{{ o.ListDesc }}
			</option>
		</select>
	</div>

	<!--Alert-->
	<div>
		<label>Alert:</label>
		<select
			[disabled]="Saving == true || SchoolLoading == true || GroupLoading == true || ValueLoading == true || AlertLoading == true"
			class="form-control"
			name="AlertSelect"
			[(ngModel)]="selectedDetails.AlertSelectID"
		>
			<option value="" style="display: none"></option>
			<option *ngFor="let o of alertList" [ngValue]="o.AlertID">
				{{ o.Message }}
			</option>
		</select>
	</div>

	<!--Exclude-->
	<div>
		<input
			[disabled]="Saving == true || SchoolLoading == true || GroupLoading == true || ValueLoading == true || AlertLoading == true"
			type="checkbox"
			name="ExcludeCheck"
			id="ExcludeCheck"
			[(ngModel)]="selectedDetails.Exclude"
		/>
		<label for="ExcludeCheck">Exclude Students in this Group</label>
	</div>
</div>

<!--Buttons-->
<div class="groups-PopupButtons">
	<!--Update-->
	<button
		[disabled]="Saving == true || SchoolLoading == true || GroupLoading == true || ValueLoading == true || AlertLoading == true"
		class="btn btn-primary groups-ButtonSpacing"
		(click)="EditGroupUpdateClick()"
	>
		Update
	</button>

	<!--Close-->
	<button [disabled]="Saving == true" class="btn btn-primary groups-ButtonSpacing" (click)="CancelAddGroupClick(0)">Close</button>
</div>

<!--Error Message-->
<div class="form-group groups-TopMargin">
	<div name="errorMessage" *ngIf="errorMessage" class="alert alert-danger">
		{{ errorMessage }}
	</div>
</div>
